import React, { useEffect, useState } from "react";
import { Box } from "grommet";
import { HeaderNavigation } from "../../components/Headers/GlobalHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import { Text } from "grommet";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL from "../../config/config";
import HandleAssessmentConfirmation from "../../components/InvitePage/HandleAssessmentConfirmation";
import { useLocation } from "react-router-dom";
const AssessmentConfirmationPage = () => {
  const useQueryParams = () => {
    return new URLSearchParams(useLocation().search);
  };

  const queryParams = useQueryParams();
  const id = queryParams.get("id");
  const [managerDetails, setManagerDetails] = useState(null);
  const [error, setError] = useState(null);
  const { manager_id, user_id, assessment_id } = useParams();

  const getManagerDetails = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/user/invite_manager_details/${manager_id}`,
      );
      setManagerDetails(response.data.manager[0]);
      console.log("Manager details:", response.data.manager[0].manager_name);
    } catch (error) {
      console.log("Error fetching manager details:", error);
      setError(
        error.response?.data?.message || error.message || "An error occurred.",
      );
    }
  };

  useEffect(() => {
    getManagerDetails();
    console.log("User email", id);
  }, []);

  return (
    <Box fill="vertical" justify="between">
      {/* Main content container */}
      <Box flex="grow">
        <HeaderNavigation quizStarted={true} />
        <Box
          direction="row"
          justify="between"
          align="center"
          margin={{ horizontal: "large" }}
          pad={{ horizontal: "large" }}
          fill="vertical" // Fills the vertical space
          height={{ min: "medium" }} // Optional: sets a minimum height to the content
        >
          {/* Right side with invite confirmation */}
          <Box align="end" pad={{ left: "medium" }}>
            {managerDetails && (
              // Pass ONLY the manager's name
              <HandleAssessmentConfirmation
                managerName={managerDetails.manager_name}
                user_id={user_id}
                assessment_id={assessment_id}
                manager_id = {manager_id}
              />
            )}
            {error && <Text color="status-critical">{error}</Text>}
          </Box>
        </Box>
      </Box>
      <StickyFooter />
    </Box>
  );
};

export default AssessmentConfirmationPage;
